import React from 'react';
import PropTypes from 'prop-types';
import { isString, kebabCase } from 'lodash';
import { FlexLoadingSpinner } from 'components/helpers/LoadingSpinner';

const Card = ({ data, title, isLoading }) => {
  const prefix = kebabCase(title);

  if (isLoading) {
    return (
      <div className='column medium-4 small-12 o-dashboard-card__wrap'>
        <strong>{title}</strong>
        <div className='o-dashboard-card u-flex u-pading-bottom--gutter cs-bg--light'>
          <FlexLoadingSpinner />
        </div>
      </div>
    )
  }

  const rows = data.map((row, idx) => (
    <div key={`${prefix}-${idx}`} className='column medium-6 small-12'>
      <span className='u-txt--stat-value'>{isString(row.value) ? row.value : Math.round(row.value)}</span><br />
      <span className='u-txt--stat-label word-break'>{row.label}</span>
    </div>
  ));
  return (
    <div className='column medium-4 small-12 o-dashboard-card__wrap'>
      <strong>{title}</strong>
      <div className='o-dashboard-card u-flex u-pading-bottom--gutter cs-bg--light'>
        {rows}
      </div>
    </div>
  )
}

Card.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
}

export default Card;
